import { CloudStore } from "@omni/types/api/store/cloud/store.model";
import { cn } from "@omni/utils/styles";
import { useCallback } from "react";

import { Anchor } from "@/components/General/Anchor/anchor.component";
import { Divider } from "@/components/General/Divider/divider.component";
import { StoreCard } from "@/components/Store/StoreSearch/components/list/storeCard/storeCard.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";
import { parseCountryToISO } from "@/utils/textUtils";

import { getStoreInfo } from "../../utils/storeInfo";
import { useStoreFullName } from "../../utils/useStoreFullName.hook";

export type StoreFlyoutProps = {
    store?: CloudStore | null;
    link: string;
};

const StoreFlyout = ({ store }: StoreFlyoutProps) => {
    const { t } = useGranite();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    const getStoreUrl = useCallback(
        (storeDetail: CloudStore) => {
            return `${Config.pages.stores}${storeDetail.code}/`;
        },
        [store]
    );

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    const getOpenInfo = useCallback(
        (storeDetails: CloudStore) => getStoreInfo(storeDetails, t),
        [store]
    );

    const storeFullName = useStoreFullName(store);

    if (!store) {
        return null;
    }

    const storeStatus = getOpenInfo(store);

    const storeAddressLines = [
        `${store.address.streetName || ""} ${store.address.streetNumber || ""}`,
        `${store.address.postalCode || ""} ${store.address.town || ""}`
    ];

    return (
        <div className={cn("tw:text-black")}>
            <Divider
                marginTop={"2"}
                className={cn("tw:mb-4")}
            />
            <h3 className={cn("tw:text-primary tw:mx-4")}>
                {t("header.navigation.shopfinder.title")}
            </h3>
            <StoreCard
                className={cn("tw:p-0 tw:mx-4")}
                isOpen={storeStatus.isOpen}
                name={storeFullName || ""}
                addressLines={storeAddressLines}
                phone={store.address.phone1}
                countryCode={parseCountryToISO(store.address.country)}
                openClosesAt={storeStatus.text2}
            />
            <p className={cn("tw:mt-2 tw:mb-0 tw:mx-4")}>
                <a href={getStoreUrl(store)}>
                    {t("header.navigation.shopfinder.showShop")}
                </a>
            </p>
            <Divider className={cn("tw:my-4")} />
            <p className={cn("tw:my-0 tw:mx-4")}>
                <Anchor
                    fullWidth={true}
                    color={"primary"}
                    outline={true}
                    href={Config.pages.stores}
                >
                    {t("header.navigation.shopfinder.showAll")}
                </Anchor>
            </p>
        </div>
    );
};

export { StoreFlyout };
